import {
    DELETE_ASSET_REQUEST,
    DELETE_ASSET,
    CLEAR_STORE
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
export const getAssetDeleteAction = getApiActionCreator(DELETE_ASSET);
export const deleteAssetRequest = (assetId, gatewayId, onResetAssetInfo) => ({
    type: DELETE_ASSET_REQUEST,
    assetId,
    gatewayId,
    onResetAssetInfo
});

export const clearStore = () => {
    return {
        type: CLEAR_STORE
    };
};
